import { Injectable } from '@angular/core'
import { MatDialog, MatDialogConfig } from '@angular/material/dialog'
import { catchError, switchMap, take } from 'rxjs/operators'
import { DialogService, HttpGetRequestCacheService } from '../../services'
import { HelpVideoDialogComponent } from './help-video-dialog.component'
import { RelatedVideosOverlayComponent } from './related-videos-overlay.component'
import { VideoItem, PlaylistItem } from './video-player'
import { of } from 'rxjs'

@Injectable()
export class HelpVideoDialogService {
  constructor(private dialogService: DialogService, private httpCache: HttpGetRequestCacheService) {}

  getRelatedVideos() {
    return this.httpCache.cacheGetRequest<PlaylistItem[]>(`/assets/data/playlists.json`).pipe(catchError(() => of([])))
  }

  public open(videoId: string) {
    this.getRelatedVideos()
      .pipe(
        switchMap((relatedVideos) => {
          const defaultConfig: MatDialogConfig = {
            width: '750px',
            height: 'auto',
            data: {
              videoId,
              relatedVideos,
              openRelatedVideos: this.openRelatedVideos.bind(this),
            },
          }

          return this.dialogService.openFixedDialog(HelpVideoDialogComponent, defaultConfig).afterClosed()
        })
      )
      .subscribe()
  }

  public openRelatedVideos(relatedVideos: VideoItem[]) {
    this.dialogService.openDrawer(RelatedVideosOverlayComponent, {
      panelClass: 'drawer-related-videos',
      data: {
        videos: relatedVideos,
        openVideo: this.open.bind(this),
      },
    })
  }
}
